import { Event } from '@nostr/tools/wasm'
import { getNoteBech32Id } from './event'
import { isHex32 } from '@nostr/gadgets/utils'
import { AddressPointer, EventPointer, neventEncode, npubEncode } from '@nostr/tools/nip19'

export const redirectLegacyHexPath = (url: string): string => {
  const segments = url.split('/')
  const kind = segments[1]
  const hex = segments[2]
  if ((kind !== 'e' && kind !== 'p') || !hex || hex.length !== 64 || !isHex32(hex)) {
    return url
  }
  const bech32 = kind === 'e' ? neventEncode({ id: hex }) : npubEncode(hex)
  const rest = segments.slice(3).filter(Boolean).join('/')
  return rest ? `/${bech32}/${rest}` : `/${bech32}`
}
export const toHome = () => '/'
export const toNote = (eventOrId: Event | string | EventPointer | AddressPointer) => {
  if (typeof eventOrId === 'string') {
    if (eventOrId.startsWith('nevent') || eventOrId.startsWith('naddr')) {
      return `/${eventOrId}`
    }
    if (isHex32(eventOrId)) {
      return `/${neventEncode({ id: eventOrId })}`
    }
    return `/${eventOrId}`
  }
  const nevent = getNoteBech32Id(eventOrId)
  return `/${nevent}`
}

export const toProfile = (userId: string, options?: { groupedSince?: number }) => {
  let path: string
  if (userId.startsWith('npub') || userId.startsWith('nprofile')) {
    path = `/${userId}`
  } else {
    const npub = npubEncode(userId)
    path = `/${npub}`
  }

  const query = new URLSearchParams()
  if (options?.groupedSince) {
    query.set('gs', options.groupedSince.toString())
  }

  const queryString = query.toString()
  if (queryString) {
    path += `?${queryString}`
  }

  return path
}
export const toGroupedProfile = (userId: string) => {
  let path: string
  if (userId.startsWith('npub') || userId.startsWith('nprofile')) {
    path = `/${userId}/grouped`
  } else {
    const npub = npubEncode(userId)
    path = `/${npub}/grouped`
  }
  return path
}
export const toFollowingList = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/following`
}
export const toFavoriteRelays = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/favorite-relays`
}
export const toBlossom = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/blossom`
}
export const toAbout = () => '/about'
export const toTheme = () => '/theme'
export const toProfileEditor = () => '/profile-editor'
export const toRelay = (url: string) => `/?r=${url.replace(/^wss:\/\//, '').replace(/\/+$/, '')}`
export const toExternalContent = (url: string) => `/external-content?i=${encodeURIComponent(url)}`

export const toMuteList = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/mutes`
}
export const toInbox = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/inbox`
}
export const toOutbox = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/outbox`
}
export const toBlockedRelays = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/blocked-relays`
}
export const toSearchRelays = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/search-relays`
}
export const toSimpleGroups = (pubkey: string) => {
  const npub = npubEncode(pubkey)
  return `/${npub}/simple-groups`
}
export const toPending = () => '/pending'
export const toShare = (id: string) => `${window.hallway.universe.baseShareURL}${id}`
